import React, { useEffect, useState } from "react";
import ClientLayout from "../../../components/client/ClientLayout";
import RequireClientAdmin from "../../../components/client/RequireClientAdmin";
import AnalysisCodesTab from "../../../components/AnalysisCodesTab";
import { clientApi, clientApiAsAdmin } from "../../../api";

const PROVIDER_LABELS = { igt: "IGT", swiftpos: "SwiftPOS", circlescan: "CircleScan", s7000: "S7000" };

export default function SettingsAnalysisCodes() {
  const [venue, setVenue] = useState(null);

  useEffect(() => {
    clientApi.getMe().then((m) => setVenue(m.venue)).catch(() => {});
  }, []);

  return (
    <ClientLayout>
      <RequireClientAdmin>
        <div className="venues-page-header">
          <div>
            <h1>Analysis Codes</h1>
            <p className="page-subtitle">Rules and per-product values</p>
          </div>
        </div>
        {venue?.provider_type !== "s7000" ? (
          <div className="empty-state">
            <h3>Not available for this provider</h3>
            <p>Analysis codes are only used by S7000 venues. This venue is configured with <strong>{PROVIDER_LABELS[venue?.provider_type] || venue?.provider_type || "another provider"}</strong>.</p>
          </div>
        ) : venue ? (
          <AnalysisCodesTab venueId={venue.id} providerType={venue.provider_type || "s7000"} api={clientApiAsAdmin} />
        ) : null}
      </RequireClientAdmin>
    </ClientLayout>
  );
}
